var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body"},[_c('TopNav'),_c('Main'),_c('Service'),_c('Footer'),_c('Feedback')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }